import { Grid } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { ROL_USER } from '../../../../app/api-client/constants';
import SimpleCard from '../../../../utils/card';
import MigaPan from '../../../../app/orussystem/component/MigaPan';


export const Datos = (props) => {

    const rol = localStorage.getItem(ROL_USER);
    const history = useHistory();

    const handleMultifiltro = () => {
        history.push(`/Multifiltro`);
    }
    const handleRegistro = () => {
        history.push(`/RegistroDeMediciones`);
    }
    const handleRegistroAlcohol = () => {
        history.push(`/RegistroAlcohol`);
    }
    const handleValidacion = () => {
        history.push(`/ValidacionDeCitas`);
    }

    return (
        <Grid container spacing={1} style={{ marginBottom: '35px', marginTop: '2%', marginLeft: 0, marginRight: 0 }}>
            <br></br>
            <br></br>

            <MigaPan
                namePage="Datos"
                to="/"
            >
                Home
            </MigaPan>

            <Grid container spacing={2} style={{ marginBottom: '35px', marginTop: '2%', marginLeft: 0, marginRight: 0 }}>
                {rol === 'ROLE_ADMIN' && <Grid item xs={12} sm={12} md={4}>
                    <SimpleCard
                        title="Multifiltro"
                        messageInfo="Multifiltro"
                        img="multifiltro"
                        event={handleMultifiltro}
                    />
                </Grid>}

                <Grid item xs={12} sm={12} md={4}>
                    <SimpleCard
                        title="Registro De Mediciones"
                        messageInfo="Registro de mediciones"
                        img="RegistroDeMediciones"
                        event={handleRegistro}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <SimpleCard
                        title="Registro De Alcoholimetria"
                        messageInfo="Registro de alcoholimetria"
                        img="RegistroDeMediciones"
                        event={handleRegistroAlcohol}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <SimpleCard
                        title="Validación de citas"
                        messageInfo="validacion de citas"
                        img="validacion"
                        event={handleValidacion}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}    